import { Component, Vue, Watch } from 'vue-property-decorator';

/**
 * Clears stale validation errors when a dialog reopens.
 *
 * Dialogs stay mounted while closed, so their ValidationObserver keeps
 * whatever errors it last had. Reopening one then showed messages like
 * "Field is required" before the user had typed anything.
 *
 * Only the observer is reset — never the form data — because edit dialogs
 * prefill their fields and clearing those would wipe the record being
 * edited. Requires ref="observer" on the ValidationObserver.
 */
@Component
export default class DialogValidationMixin extends Vue {
  @Watch('state')
  onDialogVisibilityChange(isOpen: boolean): void {
    if (!isOpen) {
      return;
    }
    this.$nextTick(() => {
      const observer = this.$refs.observer as
        | { reset?: () => void }
        | undefined;
      observer?.reset?.();
    });
  }
}
